import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Card } from '../ui/Card';
import { Users, Key, Truck } from 'lucide-react';
import { Button } from '../ui/Button';
interface UseCasesProps {
  onNavigate: (page: string) => void;
}
export function UseCases({
  onNavigate
}: UseCasesProps) {
  const cases = [{
    icon: Users,
    title: 'Privat & Familie',
    desc: 'Teilen Sie den digitalen Schlüssel sicher mit Familie und Freunden. Nie wieder physische Schlüsselübergabe.',
    features: ['Key Sharing per App', 'Klima vorab aktivieren', 'Fahrzeugstatus prüfen']
  }, {
    icon: Key,
    title: 'Car Sharing/Rental',
    desc: 'Automatisieren Sie den gesamten Mietprozess. Von der Buchung bis zur Rückgabe – komplett kontaktlos.',
    features: ['24/7 Abholung & Rückgabe', 'Automatischer Check-in', 'Digitales Protokoll']
  }, {
    icon: Truck,
    title: 'Fleet Management',
    desc: 'Optimieren Sie Ihre Flotte mit Echtzeit-Daten, Fahrer-Management und digitaler Schlüsselverwaltung.',
    features: ['Fahrer-Autorisierung', 'Nutzungsberichte', 'Wartungsalarme']
  }];
  return <section className="py-24 bg-[#0a0a0f]" data-id="element-215">
      <div className="container mx-auto px-4 md:px-6" data-id="element-216">
        <SectionHeading title="Perfekt für jeden Einsatzzweck" subtitle="Ob Privatfahrzeug, Autovermietung oder Firmenflotte – TIKA Mobility bietet die passende Lösung." align="center" data-id="element-217" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-218">
          {cases.map((item, index) => <Card key={index} className="flex flex-col h-full" data-id="element-219">
              <div className="w-12 h-12 bg-gray-800 rounded-lg flex items-center justify-center mb-6" data-id="element-220">
                <item.icon className="w-6 h-6 text-cyan-400" data-id="element-221" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-222">
                {item.title}
              </h3>
              <p className="text-gray-400 mb-6 flex-grow" data-id="element-223">{item.desc}</p>
              <ul className="space-y-2 mb-8" data-id="element-224">
                {item.features.map((feat, i) => <li key={i} className="flex items-center text-sm text-gray-300" data-id="element-225">
                    <span className="w-1.5 h-1.5 bg-cyan-500 rounded-full mr-2" data-id="element-226" />
                    {feat}
                  </li>)}
              </ul>
              <Button variant="outline" size="sm" className="w-full" onClick={() => onNavigate('solutions')} data-id="element-227">
                Mehr erfahren
              </Button>
            </Card>)}
        </div>
      </div>
    </section>;
}